module.exports = __webpack_public_path__ + "static/imgs/industrialEnterprises.90b4bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/industrialEnterprises.jpg
// module id = Oya/
// module chunks = 1